import { useSelector } from 'react-redux';
import { getIsEvolucion } from '../../authSlice/authSelectors';

function useGetIsEvolucion(): boolean {
  const isEvolucion = useSelector(getIsEvolucion);
  return isEvolucion;
}

export default useGetIsEvolucion;
